import React from 'react'

const selectedAmt = () => {
  return (
    <div className="row">
        <div className="col-lg-4">
          <div className="netbank-amt">
            <div className="selected-amt">Selected amount</div>
            <div className="total-amt">₹5000</div>
          </div>
        </div>
      </div>
  )
}

export default selectedAmt